export const UserStatuses = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  APPROVED: 'APPROVED',
  PASSWORD_REQUIRED: 'PASSWORD_REQUIRED',
} as const;
